export const kenhBan = {
  nhom: {
    BAN_OFF: '线下',
    BAN_ON: '线上',
  },
  labels: {
    TU_GIAO: '自送',
    VAN_CHUYEN_THU_3: '第三方物流',
    SHOPEE: 'Shopee',
    TIKTOK_SHOP: 'TikTok',
    LAZADA: 'Lazada',
    FACEBOOK_ZALO: 'Facebook / Zalo',
    WEBSITE: '网站',
  },
}
